<aumico-add-edit-checklist
    (onSubmitChecklistForm)="onSubmitChecklistForm($event)"
    (onCancelCheckList)="onCancelCheckList()"
    [checklist]="checklist$ | async"
    [hasFlis]="false"
></aumico-add-edit-checklist>
